import { useMemo } from 'react';
import { inlineMarkdownToHtml } from '~/lib/markdown-inline';

/**
 * FRONT-1250: renders a short description with its Markdown actually applied,
 * without any block-level element that would break the row it sits in.
 *
 * Use this for one/two-line summaries — inbox row subtitles, Files card and
 * detail descriptions. For a full document body (the inbox drawer, the zen
 * viewer) use `MarkdownRenderer` instead: there the headings and lists are the
 * point, and there is room for them.
 *
 * `as` defaults to `p` so it drops into the `<p className="line-clamp-2">`
 * subtitles it replaces; pass `span` where the surrounding markup only allows
 * phrasing content.
 */
export function InlineMarkdown({
  text,
  className = '',
  as: Tag = 'p',
}: {
  text: string;
  className?: string;
  as?: 'p' | 'span' | 'div';
}) {
  const html = useMemo(() => inlineMarkdownToHtml(text), [text]);
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
